// @ts-nocheck
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import {CloseIconButton} from "./CloseIconButton";

export const CloseButton = ({onClose}) => {
    return (
        <CloseIconButton aria-label="close" onClick={()=>onClose()}>
            <CloseIcon/>
        </CloseIconButton>
    )
    }
